import { createContext as r } from "react";
import { jsx as e } from "react/jsx-runtime";
import { useScreenRecognition as i } from "@phx-husky/use-screen-recognition";

var o = r({
  isMobile: !1,
  isTablet: !1,
  isDesktop: !1,
  isXl: !1
}),
    t = function t(_ref) {
  var r = _ref.children;
  var t = i();
  return e(o.Provider, Object.assign({
    value: t
  }, {
    children: r
  }));
};

export { o as ScreenRecognitionContext, t as ScreenRecognitionProvider };